import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'src/theming';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Contact from 'src/interfaces/api/Contact';

const useStyles = createUseStyles({
  root: {},
  title: {
    '& h2': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
  formControl: {
    marginBottom: '16px !important',
  },
});

interface Props {
  open: boolean;
  onClose: () => void;
  onValidate: () => void;
  contact: Contact;
}

const RevokeAccessDialog: React.FC<Props> = ({ open, onClose, onValidate }) => {
  const classes = useStyles();

  const [formError, setFormError] = useState<string | undefined>();

  useEffect(() => {
    setFormError(undefined);
  }, []);

  const onSubmit = async () => {
    try {
      setFormError(undefined);
      await onValidate();
    } catch (e) {
      setFormError(e.message);
    }
  };

  return (
    <Dialog onClose={onClose} scroll='paper' open={open}>
      <DialogTitle className={classes.title}>Attention</DialogTitle>

      <DialogContent>Vous êtes sur le point de supprimer l'accès à l'espace client de ce contact.</DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' color='primary' onClick={onSubmit}>
          Valider
        </Button>
      </DialogActions>

      {formError && <p className={classes.error}>{formError}</p>}
    </Dialog>
  );
};

export default RevokeAccessDialog;
